import gql from 'graphql-tag'

export const stripeTokenMutation = gql`
	mutation($userId: ID!, $paymentStripeToken: String!) {
		updateUser(
			id: $userId
			paymentStripeToken: $paymentStripeToken
		) {
			id
		}
	}
`

export const upgradeApp = gql`
	mutation ($userId: ID!) {
		upgradeApp: updateUser(
			id: $userId,
			accountPaid: true) {
				id
			}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/payment.js